export const ASSETS_PATH = '/vehicles';
export const OVERVIEW_PATH = '/overview';
export const BATTERY_HEALTH_PATH = '/batteryHealth';
export const HISTORY_PATH = '/history';
export const DEFAULT_PATH = OVERVIEW_PATH;
